import React from 'react';

import './App.scss';
import ListCountries from './features';

function App() {
  return (
    <div className="App">
      <ListCountries />
    </div>
  );
}

export default App;
